class ContentRail extends HTMLElement {
  static observer;

  constructor() {
    super();
    this._splide = null;
    this._mounted = false;
  }

  connectedCallback() {
    ContentRail.observe(this);
  }

  static observe(instance) {
    if (!ContentRail.observer) {
      ContentRail.observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const el = entry.target;

            // Mount once
            if (entry.isIntersecting && !el._mounted) {
              el.init();
              el._mounted = true;
            }

            // Play / Pause
            const autoScroll = el._splide?.Components?.AutoScroll;
            if (autoScroll) {
              entry.isIntersecting
                ? autoScroll.play()
                : autoScroll.pause();
            }
          });
        },
        {
          rootMargin: "0px",
          threshold: 0.2
        }
      );
    }

    ContentRail.observer.observe(instance);
  }

  init() {
    if (this._splide) return;

    const splideEl = this.querySelector(".splide");
    if (!splideEl) return;

    this._splide = new Splide(splideEl, {
      perPage: 4,
      gap: 16,
      type: "loop",
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 0.8,
        autoStart: false,
      },
      breakpoints: {
        1000: { perPage: 3, arrows: false },
        769: { perPage: 2, gap: 12 }
      }
    });

    this._splide.mount(window.splide.Extensions);
  }
}

customElements.define("content-rail-carousel", ContentRail);
